<template>
    <div class="modal fade" role="dialog" id="customer-present-modal">
        <div class="modal-dialog">

            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{transEdit('mark-customer-present')}}</h5>
                    <button type="button" class="close" data-dismiss="modal">
                        <span><b>x</b></span>
                    </button>
                    <input type="hidden" id="customer-present-modal-id">
                </div>
                <div class="modal-body">
                    <h4>{{transEdit('date-and-time')}}: </h4>
                    <h5>
                        <b><span id="customer-present-modal-date"></span>, </b>
                        <span id="customer-present-modal-time"></span>
                    </h5>

                    <h4>{{transEdit('customer')}}: </h4>
                    <h5><span id="customer-present-modal-customer-name"></span></h5>


                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success"
                            v-on:click="registerPresence()"><i class="fa fa-user"></i> {{transEdit('mark-customer-present')}}</button>
                    <button class="btn btn-dark"
                            data-dismiss="modal"><i class="fa fa-ban"></i> {{transEdit('cancel')}}</button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "therapist-dash-modal-customer-present",
        props: ['route_present'],
        methods: {
            registerPresence: function () {
                let self = this;
                let thisModal = $("#customer-present-modal");

                let bookingIdInput = $("#customer-present-modal-id");
                let bookingId = bookingIdInput.val();

                axios.post(this.$portalUrl(self.route_present), {
                    bookingId: bookingId,
                    markAsPresent: true,
                })
                .then(function (response) {
                    self.$emit('refresh');
                })
                .catch(function (error) {
                });

                thisModal.modal('toggle');
            }
        }
    }
</script>

<style scoped>

</style>
